"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.initialState = void 0;
const monocle = require("monocle-ts");
const fp = require("fp-ts");
const _folderTree = require("../../modules/files/tree/reducers");
const connectReducer = require("./connect");
const linkFoldersReducer = require("./linkFolders");
const linkedFoldersReducer = require("./linkedFolders");
const detachFoldersReducer = require("./detachFolders");
const resyncFoldersReducer = require("./resyncFolders");
const projectsReducer = require("./projects");
const subreducers_1 = require("../../utils/subreducers");
const folderTreeReducer = _folderTree.default('vektorio', 'NO_INHERIT_SELECTION');
exports.initialState = {
    connect: Object.assign({}, connectReducer.initialState),
    folderTree: Object.assign({}, folderTreeReducer.initialState),
    linkedFolders: Object.assign({}, linkedFoldersReducer.initialState),
    linkFolders: Object.assign({}, linkFoldersReducer.initialState),
    detachFolders: Object.assign({}, detachFoldersReducer.initialState),
    resyncFolders: Object.assign({}, resyncFoldersReducer.initialState),
    projects: Object.assign({}, projectsReducer.initialState)
};
const connectLens = monocle.Lens.fromProp('connect');
const folderTreeLens = monocle.Lens.fromProp('folderTree');
const linkedFoldersLens = monocle.Lens.fromProp('linkedFolders');
const linkFoldersLens = monocle.Lens.fromProp('linkFolders');
const detachFoldersLens = monocle.Lens.fromProp('detachFolders');
const resyncFoldersLens = monocle.Lens.fromProp('resyncFolders');
const projectsLens = monocle.Lens.fromProp('projects');
exports.default = (state = exports.initialState, action) => {
    return fp.function.flow((0, subreducers_1.handleSubreducer)(action, connectReducer, connectLens), (0, subreducers_1.handleSubreducer)(action, folderTreeReducer, folderTreeLens), (0, subreducers_1.handleSubreducer)(action, linkedFoldersReducer, linkedFoldersLens), (0, subreducers_1.handleSubreducer)(action, linkFoldersReducer, linkFoldersLens), (0, subreducers_1.handleSubreducer)(action, projectsReducer, projectsLens), (0, subreducers_1.handleSubreducer)(action, detachFoldersReducer, detachFoldersLens), (0, subreducers_1.handleSubreducer)(action, resyncFoldersReducer, resyncFoldersLens))(state);
};
//# sourceMappingURL=index.js.map